import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { RealEstateObject } from '@immosky/types';
import { DetailPageService, I18nService } from '@immosky/shared';

@Component({
  selector: 'app-map-card',
  templateUrl: './map-card.component.html',
  styleUrls: ['./map-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapCardComponent implements OnInit {
  @Input()
  object!: RealEstateObject;
  detailPageUrl = '';

  get firstImageUrl(): string {
    const image = this.object?.topImage || this.object?.images?.[0];
    return `url('${image?.url}')`;
  }

  constructor(
    private detailPageService: DetailPageService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.updateDetailPageUrl();
  }

  private updateDetailPageUrl() {
    this.detailPageUrl = this.detailPageService.getDetailPageUrlForId(
      this.object.id
    );
  }

  get price(): string {
    return this.i18nService.renderPrice(this.object);
  }

  onLinkClick(event: MouseEvent) {
    event.preventDefault();
    this.detailPageService.goTo(this.detailPageUrl, 'map-card');
  }
}
